import { useCallback } from 'react'

import { useProcurifyIntl } from '@webapp/hooks'
import {
  GuidedIntakeEntryPoints,
  GuidedIntakePromoCard,
  useStartGuidedIntake,
  useTrackGuidedIntakeEntryPointShown,
} from '@webapp/platform/global-command'
import messages from '../messages'
import { QuickRequestGuidedIntakePromoStyled } from '../styles/QuickRequestGuidedIntakePromoStyled'

interface IQuickRequestGuidedIntakePromoProps {
  onDismissMenu: () => void
}

export const QuickRequestGuidedIntakePromo = ({
  onDismissMenu,
}: IQuickRequestGuidedIntakePromoProps) => {
  const intl = useProcurifyIntl()
  const startGuidedIntake = useStartGuidedIntake()

  useTrackGuidedIntakeEntryPointShown(GuidedIntakeEntryPoints.REQUEST_DROPDOWN)

  const handleTryGuidedIntake = useCallback(() => {
    onDismissMenu()
    startGuidedIntake({
      entryPoint: GuidedIntakeEntryPoints.REQUEST_DROPDOWN,
      primaryCategoryId: null,
      secondaryCategoryId: null,
    })
  }, [onDismissMenu, startGuidedIntake])

  return (
    <QuickRequestGuidedIntakePromoStyled>
      <GuidedIntakePromoCard
        analyticsId='request-dropdown-guided-intake-promo'
        title={intl.formatMessage(messages.quickRequestGuidedIntakeTitle)}
        description={intl.formatMessage(
          messages.quickRequestGuidedIntakeDescription
        )}
        actionLabel={intl.formatMessage(
          messages.quickRequestGuidedIntakeAction
        )}
        onAction={handleTryGuidedIntake}
      />
    </QuickRequestGuidedIntakePromoStyled>
  )
}
